import * as Pickr from '@simonwep/pickr/dist/pickr.es5.min';
import { ww } from 'bobjoll/ts/library/dom';
import { EventTracker } from 'Library/eventTacker';
import getXHR from 'Partials/xhr';
import { Color } from 'Pods/editor/color';
import { LazyModal } from 'Project/ts/pods/modals/lazyModal';
import User from 'Project/ts/pods/user/main';

import { Editor } from './editor';

ww.Pickr = Pickr;

export class ColorPalette {
    private static colorPaletteButton: HTMLElement;
    private static savePaletteButton: HTMLElement | null;
    private static cancelEditionButton: HTMLElement | null;
    private static editPaletteInputButton: HTMLInputElement | null;
    private static paletteEditColorPickerButton: HTMLElement | null;
    private static palettes: Palettes;
    private static isOnEdition: boolean = false;
    private static limitColorsIndex = 10;
    private static pickrPalette: any;

    public static init(isPremiumUser: boolean) {
        document.getElementById('section-color-palette')?.classList.remove('hidden');
        this.colorPaletteButton = document.getElementById('color-palette') as HTMLElement;
        this.savePaletteButton = document.getElementById('save-palette');
        this.cancelEditionButton = document.getElementById('cancel-edition');
        this.editPaletteInputButton = document.getElementById('edit-palette') as HTMLInputElement;
        this.paletteEditColorPickerButton = document.querySelector('#palette-edit-color-picker button');

        if (isPremiumUser) {
            this.getUserColorpalette();
            this.colorPaletteButton.addEventListener('click', ColorPalette.open);
            LazyModal.callModalRemovePalette();
            ColorPalette.handleListeners();
        } else {
            this.notPremiumUser();
        }
    }

    private static getUserColorpalette() {
        const urlUserPaletteData = `${APP_URL}ajax/user-palette`;

        getXHR(urlUserPaletteData)
            .then(response => {
                let checkUserPaletteData = response.success;

                if (checkUserPaletteData != false) {
                    this.palettes = response.data.palettes[0];
                    this.drawSwatches();
                }

                if (this.palettes.colors.length > this.limitColorsIndex) {
                    this.paletteEditColorPickerButton?.classList.add('disabled');
                } else {
                    this.paletteEditColorPickerButton?.classList.remove('disabled');
                }
            })
            .catch(error => {
                throw error;
            });
    }

    public static handleListeners() {
        this.editPaletteInputButton?.addEventListener('change', () => {
            if (this.editPaletteInputButton?.checked) {
                this.isOnEdition = true;
                this.showDeleteSwatchesButtons();
                this.showSaveButton();
                this.showCancelButton();
            }
        });
        this.savePaletteButton?.addEventListener('click', () => {
            this.savePalette();
        });
        this.cancelEditionButton?.addEventListener('click', () => {
            this.cancelEdition();
        });

        window.addEventListener('modal-loaded-modal-remove-palette', () => {
            document.querySelector('#modal-remove-palette button.remove-palette')?.addEventListener('click', () => {
                this.removePalette();
            });
            document.querySelector('#modal-remove-palette button.no-thanks-palette')?.addEventListener('click', () => {
                this.noThanks();
            });
        });
    }

    private static open() {
        if (!ColorPalette.pickrPalette && !this.paletteEditColorPickerButton?.classList.contains('disabled')) {
            EventTracker.send('ga', 'event', 'editor', 'add-custom-color', 'premium');
            ColorPalette.pickrPalette = ww.Pickr.create({
                el: '#palette-edit-color-picker',
                container: '.color-palette-wrapper',
                showAlways: false,
                inline: false,
                comparison: false,
                useAsButton: true,
                defaultRepresentation: 'HEX',
                default: '#3A7C78',
                swatches: [],
                components: {
                    preview: false,
                    opacity: true,
                    hue: true,
                    interaction: {
                        hex: false,
                        rgba: false,
                        hsla: false,
                        hsva: false,
                        cmyk: false,
                        input: true,
                        clear: false,
                        save: false,
                    },
                },
            });
            let saveColorButton = document.createElement('button');
            saveColorButton.id = 'save-button-palette';
            saveColorButton.className =
                'bj-button bj-button--sm font-sm bj-button--primary bj-button--green mg-none mg-top-lv2-i';
            saveColorButton.innerText = messages.colorPalette.save;

            document.querySelector('.color-palette-wrapper .pcr-app')?.appendChild(saveColorButton);
            document.querySelector('.color-palette-wrapper .pcr-result')?.setAttribute('maxlength', '7');
            document.getElementById('save-button-palette')?.addEventListener('click', function() {
                ColorPalette.saveColorToPalette();
            });
        }
        const pcrApp: HTMLElement | null = document.querySelector('.color-palette-wrapper .pcr-app');
        if (pcrApp) {
            pcrApp.style.display = 'flex';
        }
    }

    private static saveColorToPalette() {
        const inputValue = document.querySelector(
            '.color-palette-wrapper .pcr-interaction .pcr-result',
        ) as HTMLInputElement;

        if (this.palettes.colors.length > this.limitColorsIndex) {
            this.paletteEditColorPickerButton?.classList.add(
                'disabled',
                'tooltip__trigger',
                'tooltip__trigger--always',
            );
            User.alert('notification-search', messages.colorPalette.exceeded, 'warning', 'bottom-left', 4500);
            const pcrApp: HTMLElement | null = document.querySelector('.color-palette-wrapper .pcr-app');
            if (pcrApp) {
                pcrApp.style.display = 'none';
            }
        } else {
            if (this.palettes.colors.indexOf(inputValue.value) === -1) {
                this.palettes.colors.push(inputValue.value);
                if (this.palettes.colors.length > this.limitColorsIndex) {
                    this.paletteEditColorPickerButton?.classList.add(
                        'disabled',
                        'tooltip__trigger',
                        'tooltip__trigger--always',
                    );
                }
                this.sendDataColorPalette();
            } else {
                User.alert('notification-search', messages.colorPalette.alredyExist, 'warning', 'bottom-left', 4500);
            }
        }
        this.drawSwatches();
    }

    private static drawSwatches() {
        document.querySelectorAll('.swatch').forEach(el => el.remove());
        const isOnEdition = this.isOnEdition ? '' : 'hidden';
        const filled = this.palettes.colors.length > this.limitColorsIndex ? true : false;

        filled
            ? this.paletteEditColorPickerButton?.classList.add(
                  'disabled',
                  'tooltip__trigger',
                  'tooltip__trigger--always',
              )
            : this.paletteEditColorPickerButton?.classList.remove(
                  'disabled',
                  'tooltip__trigger',
                  'tooltip__trigger--always',
              );

        if (this.palettes.colors.length > 0) {
            this.palettes.colors.forEach((swatch, index) => {
                let newSwatch = document.createElement('li');
                newSwatch.className = 'swatch mg-right-lv2 mg-bottom-lv2';
                newSwatch.innerHTML = `<span class="color" style="background-color: ${swatch};" title="${swatch}"><i class="icon icon--cross-small ${isOnEdition}" data-value="${swatch}"></i></span>`;
                newSwatch.dataset.value = swatch;
                document.querySelector('ul.swatches')?.appendChild(newSwatch);
                const colorElement = newSwatch.querySelector('span.color') as HTMLElement;
                if (colorElement) {
                    this.handleSwatchListenerByColor(colorElement);
                }
            });
            document.querySelector('.color-palette__header .popover-button')?.classList.remove('hidden');
        }

        let deleteButtons = document.querySelectorAll('.swatch i');
        deleteButtons.forEach(button =>
            button.addEventListener('click', function(e) {
                e.stopPropagation();
                const target = e.target as HTMLElement;
                const colorValue = target.dataset.value;
                if (colorValue) {
                    ColorPalette.deleteSwatch(colorValue);
                }
            }),
        );
    }

    private static deleteSwatch(swatch: string) {
        this.palettes.colors = this.palettes.colors.filter(color => color !== swatch);
        this.drawSwatches();
        if (this.palettes.colors.length === 0) {
            if (this.editPaletteInputButton) {
                this.editPaletteInputButton.checked = false;
            }
            this.isOnEdition = false;
        }
    }

    private static showDeleteSwatchesButtons() {
        let deleteButtons = document.querySelectorAll('.swatch i');
        deleteButtons.forEach(button => button.classList.remove('hidden'));
    }

    private static showSaveButton() {
        this.savePaletteButton?.classList.remove('hidden');
    }
    private static showCancelButton() {
        this.cancelEditionButton?.classList.remove('hidden');
    }

    private static savePalette() {
        this.palettes.colors = this.palettes.colors;
        let editPaletteButton = document.getElementById('edit-palette') as HTMLInputElement;
        editPaletteButton.checked = false;
        this.isOnEdition = false;
        this.savePaletteButton?.classList.add('hidden');
        this.cancelEditionButton?.classList.add('hidden');

        this.sendDataColorPalette();
        this.drawSwatches();
        if (this.palettes.colors.length === 0) {
            document.querySelector('.color-palette__header .popover-button')?.classList.add('hidden');
        }
    }
    private static cancelEdition() {
        let editPaletteButton = document.getElementById('edit-palette') as HTMLInputElement;
        editPaletteButton.checked = false;
        this.isOnEdition = false;
        this.cancelEditionButton?.classList.add('hidden');
        this.savePaletteButton?.classList.add('hidden');
        this.getUserColorpalette();
        this.drawSwatches();
    }

    public static removePalette() {
        ColorPalette.palettes.colors = [];
        ColorPalette.savePalette();
        const modalClose = document.querySelector('.modal-remove-palette .modal__close') as HTMLElement;
        modalClose.click();
        document.querySelector('.color-palette__header .popover-button')?.classList.add('hidden');
    }

    public static noThanks() {
        const modalClose = document.querySelector('.modal-remove-palette .modal__close') as HTMLElement;
        modalClose.click();
    }

    private static notPremiumUser() {
        const colorPaletteHeader = document.querySelector(
            'section.color-palette .color-palette__header',
        ) as HTMLDivElement;
        colorPaletteHeader.style.display = 'block';
        const title = colorPaletteHeader.querySelector('p') as HTMLElement;
        title.style.display = 'inline';
        colorPaletteHeader.querySelector('i')?.classList.remove('hidden');
        this.colorPaletteButton.classList.add('modal__trigger');
        this.colorPaletteButton.dataset.modal = 'modal-palette-not-premium-user';
        LazyModal.callModalPaletteNotPremiumUser();

        window.addEventListener('modal-loaded-modal-palette-not-premium-user', () => {
            document.querySelector('#modal-palette-not-premium-user a')?.addEventListener('click', () => {
                EventTracker.send('ga', 'event', 'editor', 'add-custom-color', 'registered');
                EventTracker.send('ga4dl', {
                    event: 'ga4event',
                    event_name: 'microfunnel',
                    location: 'popup_custom_palette',
                    interaction_type: 'click',
                    action: 'go_premium',
                    product_price: 'full_price',
                    campaign_name: 'no_campaign',
                    discount_type: '0',
                });
            });
        });
    }

    private static sendDataColorPalette() {
        const urlUserPalette = `${APP_URL}ajax/user-palette/${this.palettes.id}`;

        getXHR(urlUserPalette, {
            method: 'POST',
            data: JSON.stringify({ colors: this.palettes.colors }),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).catch(err => {
            User.alert('notification-colorpalette', messages.colorPalette.updatingError, 'warning', 'bottom-left');
        });
    }

    private static handleSwatchListenerByColor(colorElement: HTMLElement) {
        colorElement?.addEventListener('click', (e: Event) => {
            const buttonElement = e.currentTarget as HTMLElement;

            if (!this.isOnEdition && buttonElement && buttonElement.title) {
                let activeColor = document.querySelector('#svg-icon-colors .color .active') as HTMLElement;
                if (activeColor.style.background.includes('linear-gradient')) {
                    User.alert(
                        'notification-colorpalette',
                        messages.colorPalette.noGradients,
                        'warning',
                        'bottom-left',
                    );
                } else {
                    Editor.pickr.setColor(buttonElement.title.toLowerCase());
                    Color.fireChangeColor(buttonElement.title.toLowerCase(), true);
                    Color.setSVGColor(buttonElement.title.toLowerCase());
                }
            }
        });
    }
}

interface Palettes {
    id: string;
    colors: string[];
}
